import type { ReactNode } from "react";
import { AlertTriangle, Info } from "lucide-react";

import styles from "./AuthLayout.module.css";

interface Props {
  variant: "info" | "warn";
  className?: string;
  children: ReactNode;
}

export function AuthNotice({ variant, className, children }: Props) {
  const Icon = variant === "info" ? Info : AlertTriangle;
  const cls = [
    styles.notice,
    variant === "info" ? styles.noticeInfo : styles.noticeWarn,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls}>
      <Icon size={15} className={styles.noticeIcon} aria-hidden="true" />
      <div>{children}</div>
    </div>
  );
}
